import { createFileRoute } from "@tanstack/react-router";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN, ROLE_USER } from "@/constants";
import { Button, CardContent, CardHeader, Grid, Stack } from "@mui/material";
import AppCard from "@/components/AppCard.tsx";

import { PermissionGuard } from "@/auth/PermissionGuard.tsx";

export const Route = createFileRoute("/_dashboard/showcase/user-admin-page")({
  beforeLoad: (args) => {
    requireRole([ROLE_ADMIN, ROLE_USER])(args);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Grid container spacing={6}>
      <Grid size={{ xs: 12 }}>
        <AppCard>
          <CardHeader title={`Page user & admin`} />
          <CardContent>
            <Stack
              sx={{
                gap: 2,
                alignItems: "flex-start",
              }}
            >
              <PermissionGuard admin>
                <Button variant="contained">Bouton admin</Button>
              </PermissionGuard>
              <PermissionGuard roles={[ROLE_USER]}>
                <Button variant="contained">Bouton user</Button>
              </PermissionGuard>
              <PermissionGuard roles={[ROLE_USER, ROLE_ADMIN]}>
                <Button variant="contained">Bouton admin & user</Button>
              </PermissionGuard>
            </Stack>
          </CardContent>
        </AppCard>
      </Grid>
    </Grid>
  );
}
